var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnWebhook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H89.6641C94.0823 0 97.6641 3.58172 97.6641 8V89.6641C97.6641 94.0823 94.0823 97.6641 89.6641 97.6641H8C3.58172 97.6641 0 94.0823 0 89.6641V8Z",
    fill: "#FFE4E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0551 63.4808H36.3777V66.4449C35.84 69.4834 33.1752 71.7918 29.9688 71.7918C26.3746 71.7918 23.4609 68.8913 23.4609 65.3133C23.4609 63.1055 24.5704 61.1556 26.2646 59.986L24.3984 57.332C21.8651 59.0875 20.207 62.0077 20.207 65.3133C20.207 70.6803 24.5775 75.031 29.9688 75.031C34.8036 75.031 38.8175 71.532 39.5945 66.9389H63.9234C64.4869 67.9038 65.5366 68.5526 66.7386 68.5526C68.5356 68.5526 69.9925 67.1023 69.9925 65.3133C69.9925 63.5243 68.5356 62.0741 66.7386 62.0741C65.6247 62.0741 64.6416 62.6312 64.0551 63.4808Z",
    fill: "#EE6989",
    stroke: "#313131"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0582 63.9656C27.1144 63.8266 27.1809 63.6898 27.258 63.5563C27.8559 62.5208 28.9383 61.9396 30.0529 61.934L42.2552 40.7991C38.6596 37.832 37.6263 32.6153 40.0362 28.4412C42.7223 23.7887 48.6689 22.1931 53.3182 24.8774C56.1726 26.5254 57.8745 29.4035 58.1414 32.4567L54.9126 32.7398C54.7351 30.7037 53.6004 28.7844 51.697 27.6854C48.5974 25.8959 44.6331 26.9596 42.8423 30.0613C41.0886 33.0988 42.0699 36.9644 45.0224 38.8037L46.8067 39.8339L32.9861 63.7718C33.3789 64.5921 33.4212 65.5652 33.0469 66.4432C32.5901 67.6796 31.4001 68.5612 30.0041 68.5612C28.2134 68.5612 26.7617 67.1105 26.7617 65.321C26.7617 64.8371 26.8679 64.378 27.0582 63.9656Z",
    fill: "#EE6989",
    stroke: "#313131"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1733 36.5115L61.8556 60.2099L63.485 59.2691L63.5126 59.317C63.5261 59.3091 63.5396 59.3012 63.5531 59.2934C66.6548 57.5027 70.6064 58.5402 72.3792 61.6109C74.1521 64.6816 73.0749 68.6226 69.9732 70.4133C68.061 71.5173 65.8259 71.5464 63.9774 70.6869L62.5972 73.6095C65.3676 74.8927 68.7144 74.8467 71.5782 73.1933C76.2307 70.5072 77.8466 64.5957 75.1873 59.9897C72.7862 55.8309 67.721 54.1583 63.3353 55.8498L51.195 34.8222C51.718 33.8686 51.7474 32.6791 51.168 31.6756C50.2816 30.1403 48.3058 29.6215 46.7549 30.5168C45.2041 31.4122 44.6655 33.3827 45.5519 34.9181C46.1153 35.8938 47.1186 36.459 48.1733 36.5115Z",
    fill: "#EE6989",
    stroke: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnWebhook);
export default __webpack_public_path__ + "static/media/conn_webhook.72d7d73273ee5de81708d1e96d8dd0e9.svg";
export { ForwardRef as ReactComponent };